import { initializeMixpanel } from '@lib/Mixpanel'

initializeMixpanel()
